<app-auth-pages>
  <ng-container *transloco="let t;">
    <h2 class="card-title fw-bold text-black mb-1 mobile-adjustment">{{ t('SSO Login label - (SSO Login) - SSO Login') }}</h2>

    <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
      <div class="alert-body"><p>{{ error }}</p></div>
    </ngb-alert>

    <form class="auth-login-form mt-2" [formGroup]="ssoForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label class="form-label" for="sso-email">{{t('Email (general) - Email')}}</label>
        <input id="sso-email" type="text" formControlName="email" class="form-control placeholder-text" [ngClass]="{ 'is-invalid': submitted && form.email.errors }" autofocus tabindex="1" />
        <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
          <div *ngIf="form.email.errors.required">{{ t('Field required (form validation) - Field name is required', { fieldName: t('Email (general) - Email') }) }}</div>
          <div *ngIf="form.email.errors.email">{{ t('Email must be a valid email address (general) - Email must be a valid email address') }}</div>
        </div>
      </div>

      <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="2">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
        {{ t('Sign in button name (Login page) - Sign in') }}
      </button>
    </form>

    <p class="text-center mt-2">
      <a routerLink="/login">{{ t('Sign in instead text (Authorization pages) - Sign in instead') }}</a>
    </p>
  </ng-container>
</app-auth-pages>
